var Rating = function(){
	$(".star").on("click", function() {
		var pageId = $(this).parents(".stars").data("page");
		var rating = $(this).index() + 1;

		$.get("/" + "rating/add/" + rating + "/" + pageId);
		var $count = $(this).parents(".rating-box").find(".count");
		$count.html(parseInt($count.html()) + 1);

		$(".star").off().hide();
		$(".rating-box .thanks").show();
	});
};

module.exports = Rating;
